/**
 * CSV fuer den Tabellen-Export (V-16). Semikolon und Komma als Dezimalzeichen,
 * damit Excel und LibreOffice in deutscher Einstellung die Datei direkt
 * richtig oeffnen. Ein BOM vorne sorgt fuer korrekte Umlaute.
 */
export type CsvWert = string | number | null | undefined;

const zelle = (v: CsvWert): string => {
  if (v === null || v === undefined) return '';
  const text = typeof v === 'number' ? (Number.isFinite(v) ? String(v).replace('.', ',') : '') : v;
  return /[;"\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function csvText(kopf: string[], zeilen: CsvWert[][]): string {
  return [kopf, ...zeilen].map((z) => z.map(zelle).join(';')).join('\r\n');
}

/** Bietet den Text als Datei zum Speichern an. */
export function csvSpeichern(dateiname: string, text: string) {
  const blob = new Blob(['﻿', text], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = dateiname.endsWith('.csv') ? dateiname : `${dateiname}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
